import {
  type CreateHeroInclusionRequest,
  type UpdateHeroInclusionRequest,
  type HeroInclusionDetail,
  HeroInclusionDetailSchema,
  type HeroInclusionListQuery,
  type HeroInclusionListResponse,
  HeroInclusionListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Hero inclusions (icon + name strip) admin API. Every response is validated
 * with the shared Zod schema.
 */

const BASE = '/admin/website/hero-inclusions';

export const listHeroInclusions = async (
  query: HeroInclusionListQuery,
): Promise<HeroInclusionListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return HeroInclusionListResponseSchema.parse(data);
};

export const getHeroInclusion = async (id: string): Promise<HeroInclusionDetail> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}`);
  return HeroInclusionDetailSchema.parse(data);
};

export const createHeroInclusion = async (
  payload: CreateHeroInclusionRequest,
): Promise<HeroInclusionDetail> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return HeroInclusionDetailSchema.parse(data);
};

export const updateHeroInclusion = async (
  id: string,
  payload: UpdateHeroInclusionRequest,
): Promise<HeroInclusionDetail> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return HeroInclusionDetailSchema.parse(data);
};

export const deleteHeroInclusion = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
